import api from './api';

const previousHubService = {
  async checkArchive() {
    const response = await api.get('/partners/country-hub/previous-archive');
    return response.data;
  },

  async importSelective(selection) {
    const response = await api.post('/partners/country-hub/import-previous', selection);
    return response.data;
  }
};

export default previousHubService;
